import https from "./https";
import store from "@/store";

const customer = {
  listV2(params) {
    const organization = store.state.general.organization;
    return https.get(
      `/admin/organizations/${organization.id}/customers`,
      {
        params,
      }
    );
  },
  listWithProfile(merchantID, params) {
    const organization = store.state.general.organization;
    return https.get(
      `/admin/organizations/${organization.id}/merchants/${merchantID}/customers-with-profile`,
      {
        params,
      }
    );
  },
  getSameUserCustomers(customerID) {
    const organization = store.state.general.organization;
    return https.get(
      `/admin/organizations/${organization.id}/customers/${customerID}/same-user-customers`
    );
  },
  getCustomer(customerID) {
    const organization = store.state.general.organization;
    return https.get(
      `/admin/organizations/${organization.id}/customers/${customerID}`
    );
  },

  storeCustomer(customerId, params) {
    const organization = store.state.general.organization;
    return https.put(
      `/admin/organizations/${organization.id}/customers/${customerId}`, params
    );
  },

  getCustomerProfiles(customerId) {
    const organization = store.state.general.organization;
    return https.get(
      `/admin/organizations/${organization.id}/customers/${customerId}/profiles`
    );
  },

  storeCustomerProfiles(customerId, params) {
    const organization = store.state.general.organization;
    return https.put(
      `/admin/organizations/${organization.id}/customers/${customerId}/profiles`, params
    );
  },

  getCustomerTags(customerId) {
    const organization = store.state.general.organization;
    return https.get(
      `/admin/organizations/${organization.id}/customers/${customerId}/tags`
    );
  },

  setCustomerTags(customerId, params) {
    const organization = store.state.general.organization;
    return https.put(
      `/admin/organizations/${organization.id}/customers/${customerId}/tags`, params
    );
  },

  unbind(customerID) {
    const organization = store.state.general.organization;
    return https.put(
      `/admin/organizations/${organization.id}/customers/${customerID}/unbind`
    );
  },
  reset(customerID) {
    const organization = store.state.general.organization;
    return https.put(
      `/admin/organizations/${organization.id}/customers/${customerID}/reset`
    );
  },
  unregister(customerID) {
    const organization = store.state.general.organization;
    return https.put(
      `/admin/organizations/${organization.id}/customers/${customerID}/unregister`
    );
  },
  registerCustomer(customerID, params) {
    const organization = store.state.general.organization;
    return https.post(
      `/admin/organizations/${organization.id}/customers/${customerID}/register`, params
    );
  },
  quicklyUnbind(customerID) {
    const organization = store.state.general.organization;
    return https.put(
      `/admin/organizations/${organization.id}/customers/${customerID}/quickly-unbind`
    );
  },
  importCustomers(merchantID, data) {
    const organization = store.state.general.organization;

    return https.post(
      `/admin/organizations/${organization.id}/merchants/${merchantID}/customers/import`,
      data
    );
  },
  exportFailedCustomers(merchantID, data) {
    const organization = store.state.general.organization;

    return https.post(
      `/admin/organizations/${organization.id}/merchants/${merchantID}/customers/export-failed-customers`,
      data
    );
  },
  getStaffs(customerID, params) {
    const organization = store.state.general.organization;
    return https.get(
      `/admin/organizations/${organization.id}/customers/${customerID}/staffs`,
      { params }
    );
  },
  changeStaff(customerID, params) {
    const organization = store.state.general.organization;
    return https.post(
      `/admin/organizations/${organization.id}/customers/${customerID}/change-staff`,
      params
    );
  },
  unbindStaff(customerID, params) {
    const organization = store.state.general.organization;
    return https.post(
      `/admin/organizations/${organization.id}/customers/${customerID}/unbind-staff`,
      params
    );
  },
  changeBoundType(customerID, params) {
    const organization = store.state.general.organization;
    return https.post(
      `/admin/organizations/${organization.id}/customers/${customerID}/change-bound-type`,
      params
    );
  },
  bindStaff(customerID, params) {
    const organization = store.state.general.organization;
    return https.post(
      `/admin/organizations/${organization.id}/customers/${customerID}/bind-staff`,
      params
    );
  },
  getLineMerchantCustomers(params) {
    const organization = store.state.general.organization;
    return https.get(
      `/admin/organizations/${organization.id}/line-merchants/customers`,
      { params }
    );
  },
  merchantList() {
    const organization = store.state.general.organization;
    return https.get(`/admin/organizations/${organization.id}/customers/merchants`);
  },
  syncLineData(customerID) {
    const organization = store.state.general.organization;
    return https.post(`/admin/organizations/${organization.id}/customers/${customerID}/sync-line-data`);
  },
  clearLiffCache(customerID) {
    const organization = store.state.general.organization;
    return https.post(`/admin/organizations/${organization.id}/customers/${customerID}/clear-liff-cache`);
  },
  getBranches(customerId, params) {
    const organization = store.state.general.organization;
    return https.get(`/admin/organizations/${organization.id}/customers/${customerId}/branches`, {params});
  },
  createBranch(customerID, params) {
    const organization = store.state.general.organization;
    return https.post(`/admin/organizations/${organization.id}/customers/${customerID}/create-branch`,params);
  },
  unboundBranch(customerID, customerBranchID) {
    const organization = store.state.general.organization;
    return https.put(`/admin/organizations/${organization.id}/customers/${customerID}/${customerBranchID}/unbound`);
  },
  reboundBranch(customerID, customerBranchID) {
    const organization = store.state.general.organization;
    return https.put(`/admin/organizations/${organization.id}/customers/${customerID}/${customerBranchID}/rebound`);
  },
  deleteBranch(customerID, customerBranchID) {
    const organization = store.state.general.organization;
    return https.delete(`/admin/organizations/${organization.id}/customers/${customerID}/${customerBranchID}`);
  },
  recomputeLevel(customerID) {
    const organization = store.state.general.organization;
    return https.post(`/admin/organizations/${organization.id}/customers/${customerID}/recompute-level`);
  },
  getLevelHistory(customerID, params = {}) {
    const organization = store.state.general.organization;
    return https.get(`/admin/organizations/${organization.id}/customers/${customerID}/level-history`, { params });
  },
  getCustomersByOuterCode(outerCode) {
    const organization = store.state.general.organization;
    return https.get(`/admin/organizations/${organization.id}/customers/outer-code/${outerCode}`);
  },
  mergeCustomers(fromOuterCode, toOuterCode) {
    const organization = store.state.general.organization;
    return https.post(`/admin/organizations/${organization.id}/customers/merge`, { from: fromOuterCode, to: toOuterCode });
  },
  manuallyVerifyPhone(customerID, mobilePhone) {
    const organization = store.state.general.organization;
    return https.put(`/admin/organizations/${organization.id}/customers/${customerID}/manually-verify-mobile-phone`, { mobile_phone: mobilePhone });
  },
  storeCustomerDetails(customerId, params) {
    const organization = store.state.general.organization;
    return https.put(
      `/admin/organizations/${organization.id}/customers/${customerId}/details`, params
    );
  },
  deleteCustomer(customerID) {
    const organization = store.state.general.organization;
    return https.delete(`/admin/organizations/${organization.id}/customers/${customerID}`);
  },
  softDeleteCustomer(customerID) {
    const organization = store.state.general.organization;
    return https.delete(`/admin/organizations/${organization.id}/customers/${customerID}/soft-delete`);
  },
  getCustomerOrders(params) {
    const organization = store.state.general.organization;
    return https.get(`/admin/organizations/${organization.id}/customers/orders`, { params });
  },
  exportCustomerOrders(params) {
    const organization = store.state.general.organization;
    return https.get(`/admin/organizations/${organization.id}/customers/orders/export`, { params });
  },
};

export default customer;
